import type { JobApi } from '@/modules/jobs/types';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  type DialogProps,
  DialogTitle,
} from '@/modules/ui/components/dialog/Dialog';
import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from '@/modules/ui/components/tabs/Tabs';

import { CvUploadForm } from './CvUploadForm';
import { LinkedInUploadForm } from './LinkedInUploadForm';

interface AddCandidatesDialogProps {
  job: JobApi;
  open: DialogProps['open'];
  onOpenChange: DialogProps['onOpenChange'];
  onSuccess: () => void;
  onCancel: () => void;
}

export const AddCandidatesDialog = ({
  job,
  open,
  onOpenChange,
  onSuccess,
  onCancel,
}: AddCandidatesDialogProps) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-3xl">
        <DialogHeader>
          <DialogTitle>Add candidates - {job.title}</DialogTitle>
        </DialogHeader>
        <Tabs>
          <TabsList>
            <TabsTrigger value="cv">Upload CVs</TabsTrigger>
            <TabsTrigger value="linkedin">Add via LinkedIn</TabsTrigger>
          </TabsList>

          <div className="mt-4">
            <TabsContent value="cv">
              <CvUploadForm
                job={job}
                onSuccess={onSuccess}
                onCancel={onCancel}
              />
            </TabsContent>

            <TabsContent value="linkedin">
              <LinkedInUploadForm
                job={job}
                onSuccess={onSuccess}
                onCancel={onCancel}
              />
            </TabsContent>
          </div>
        </Tabs>
      </DialogContent>
    </Dialog>
  );
};
